import styled from 'styled-components';

// A track + coloured fill. `$share` (0–1, clamped) sets the fill width;
// `$color` is the source-type palette colour. Transient ($-prefixed) props
// so they aren't forwarded to the DOM node. Matches the codebase's
// `styled<any>('div')` pattern (see gpc-summary-table).
const Track = styled<any>('div')(({ theme }: any) => ({
  width: '100%',
  height: 8,
  borderRadius: 4,
  backgroundColor: theme.color.gray3,
  overflow: 'hidden',
}));

const Fill = styled<any>('div')(({ $share, $color }: any) => ({
  width: `${Math.max(0, Math.min(1, $share)) * 100}%`,
  height: '100%',
  backgroundColor: $color,
  borderRadius: 4,
}));

export { Track, Fill };
